import { Navigate, useLocation } from 'react-router-dom';
import { canonicalPath } from '../../utils/canonicalUrl';

/** 301-equivalent client-side: path senza slash finale → versione canonica. */
const RedirectToCanonicalSlash = () => {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={`${canonicalPath(pathname)}${search}${hash}`} replace />;
};

export default RedirectToCanonicalSlash;
